export type NotificationRecipientChannel = {
    emails: string[];
    departments: number[];
    ad_departments: string[];
    responsible_users: string[];
};

export type NotificationRecipientConfig = {
    to: NotificationRecipientChannel;
    cc: NotificationRecipientChannel;
    bcc: NotificationRecipientChannel;
    digest: boolean;
};

export type NotificationVariable = {
    token: string;
    label: string;
    description: string;
    example: string;
    is_list: boolean;
};

export class Notification {
    public id: number | null;
    public name: string;
    public emails: string;
    public description: string;
    public email_body: string;
    public email_subject: string;
    public emails_bcc: string;
    public emails_cc: string;
    public is_company_notification: boolean;
    public recipient_config: NotificationRecipientConfig | null;
    public variables: NotificationVariable[];
    public has_company_context: boolean;
    public is_digest: boolean;
    public has_definition: boolean;
    public fallback_email_keys: Record<string, string>;
    public fallback_emails: Record<string, string>;


    constructor(data: NotificationData | void) {
        if (data === undefined) {
            this.id = null;
            this.name = "";
            this.emails = "";
            this.description = "";
            this.email_body = "";
            this.email_subject = "";
            this.emails_bcc = "";
            this.emails_cc = "";
            this.is_company_notification = false;
            this.recipient_config = null;
            this.variables = [];
            this.has_company_context = false;
            this.is_digest = false;
            this.has_definition = true;
            this.fallback_email_keys = {};
            this.fallback_emails = {};

        } else {
            this.id = data.id;
            this.name = data.name;
            this.emails = data.emails;
            this.description = data.description;
            this.email_body = data.email_body;
            this.email_subject = data.email_subject;
            this.emails_bcc = data.emails_bcc;
            this.emails_cc = data.emails_cc;
            this.is_company_notification = data.is_company_notification;
            this.recipient_config = data.recipient_config ?? null;
            this.variables = data.variables ?? [];
            this.has_company_context = data.has_company_context ?? false;
            this.is_digest = data.is_digest ?? false;
            this.has_definition = data.has_definition ?? true;
            this.fallback_email_keys = data.fallback_email_keys ?? {};
            this.fallback_emails = data.fallback_emails ?? {};
        }
    }

    serializeData() {
        return {
            id: this.id,
            name: this.name,
            emails: this.emails,
            description: this.description,
            email_body: this.email_body,
            email_subject: this.email_subject,
            emails_bcc: this.emails_bcc,
            emails_cc: this.emails_cc,
            is_company_notification: this.is_company_notification,
        };
    }
}

export type NotificationData = {
    id: number | null;
    name: string;
    emails: string;
    description: string;
    email_body: string;
    email_subject: string;
    emails_bcc: string;
    emails_cc: string;
    is_company_notification: boolean;
    recipient_config?: NotificationRecipientConfig | null;
    variables?: NotificationVariable[];
    has_company_context?: boolean;
    is_digest?: boolean;
    has_definition?: boolean;
    fallback_email_keys?: Record<string, string>;
    fallback_emails?: Record<string, string>;
}
